import React from 'react';
import MessageTime from '../Common/MessageTime';
import { GoogleMapPopUP } from '../Common/GoogleMapPopUP';

const MessageDetails = ({ showActions, lat, lng, dateAndTime, isSenderMessage = false }) => {
    if (!showActions) {
        return null;
    }
    return (
        <div className={`d-flex lowerDetails py-2 ${isSenderMessage ? 'justify-content-end ' : ''}`}>
            <span className="px-2 text-right text-muted pointer">
                {lat && lng && <GoogleMapPopUP lat={lat} lng={lng} />}
            </span>
            <span className="px-2 text-right text-muted text-uppercase">
                <MessageTime dateAndTime={dateAndTime} />
            </span>
        </div>
    );
};

export default MessageDetails;
